import axios from "axios";
import urlencode from "urlencode";

// Custom Component
// import DoRefreshToken from '../components/SignIn/DoRefreshToken'
import SignOut from "../components/SignIn/SignOut";

const store = require("store");

const getFolderList = async () => {
	const getFolderList_api = "/dms/folder";
	let result;

	try {
		let headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "get",
			url: process.env.REACT_APP_API_URL_3003 + getFolderList_api,
			headers: headers,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const getFileList = async (folderSeq, page) => {
	const getFileList_api = "/dms/property/";
	let result;

	try {
		let headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		let params = {
			folder_seq: folderSeq,
			page: page,
			// limit: 600
		};

		result = await axios({
			method: "get",
			url: process.env.REACT_APP_API_URL_3003 + getFileList_api,
			headers: headers,
			params: params,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const getCompanyList = async (folderSeq) => {
	const companyList_api = `/dms/folder/${folderSeq}/company`;
	let headers;
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};
		result = await axios({
			method: "get",
			url: process.env.REACT_APP_API_URL_3003 + companyList_api,
			headers: headers,
		});

		return result.data.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
}


const getAdvSearchCompanyList = async () => {
	const getAdvSearchCompanyList_api = "/dms/property/property_companies"
	let headers;
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};
		result = await axios({
			method: "get",
			url: process.env.REACT_APP_API_URL_3003 + getAdvSearchCompanyList_api,
			headers: headers,
		});

		return result;
	}
	catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
}


const createFolder = async (parentSeq, folderName) => {
	const getFolderList_api = "/dms/folder";
	let headers;
	let params = new URLSearchParams();
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		params.append("parent_seq", parentSeq);
		params.append("name", folderName);

		result = await axios({
			method: "post",
			url: process.env.REACT_APP_API_URL_3003 + getFolderList_api,
			headers: headers,
			data: params,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const removeFolder = async (folderSeq) => {
	const removeFolder_api = `/dms/folder/${folderSeq}`;
	let headers;
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "delete",
			url: process.env.REACT_APP_API_URL_3003 + removeFolder_api,
			headers: headers,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const removeFile = async (propertySeq) => {
	const removeFile_api = "/dms/property";
	let headers;
	let params = new URLSearchParams();
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		propertySeq.map((res) => {
			params.append("property_seq", res);
		});

		result = await axios({
			method: "delete",
			url: process.env.REACT_APP_API_URL_3003 + removeFile_api,
			headers: headers,
			data: params,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const moveProperty = async (propertySeq, folderSeq) => {
	const moveProperty_api = "/dms/property/move";
	let headers;
	let params = new URLSearchParams();
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		params.append("folder_seq", folderSeq);
		propertySeq.map((res) => {
			params.append("property_seq", res);
		});

		result = await axios({
			method: "patch",
			url: process.env.REACT_APP_API_URL_3003 + moveProperty_api,
			headers: headers,
			data: params,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const getPropertyDetail = async (propertySeq) => {
	const propertyDetail_api = `/dms/property/${propertySeq}`;
	let headers;
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "get",
			url: process.env.REACT_APP_API_URL_3003 + propertyDetail_api,
			headers: headers,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const updatePropertyDetail = async (propertySeq, data) => {
	const api = `/dms/property/${propertySeq}`;
	let headers;
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "patch",
			url: process.env.REACT_APP_API_URL_3003 + api,
			headers: headers,
			data: data,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const removePropertyFile = async (propertySeq, propertyFileSeq) => {
	const api = `/dms/property/${propertySeq}/file/${propertyFileSeq}`;
	let headers;
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "delete",
			url: process.env.REACT_APP_API_URL_3003 + api,
			headers: headers,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const setPrimary = async (propertySeq, propertyFileSeq) => {
	const api = `/dms/property/${propertySeq}/file/${propertyFileSeq}/primary`;
	let headers;
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "patch",
			url: process.env.REACT_APP_API_URL_3003 + api,
			headers: headers,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const propertyDownload = async (propertySeq) => {
	const propertyDownload_api = "/dms/property/download";
	let headers;
	let queryParams;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		}

		queryParams = propertySeq.join("&property_seq=");

		// axios({
		// 	method: 'get',
		// 	url: process.env.REACT_APP_API_URL_3003 + propertyDownload_api + "?property_seq="+queryParams+"&only_primary=N",
		// 	headers: headers,
		// 	responseType: 'blob',
		// }).then(response => {
		// 	console.log(response)
		// 	const blob = new Blob([response.data], {type: response.data.type})
		// 	const downloadUrl = window.URL.createObjectURL(blob)
		// 	const link = document.createElement('a')
		// 	link.href = downloadUrl
		// 	const header_filename = response.headers['download-filename']
		// 	let filename = 'date_time'
		// 	if (header_filename) {
		// 		filename = header_filename

		// 	}
		// 	link.setAttribute('download', filename)
		// 	document.body.appendChild(link)
		// 	link.click()
		// 	link.remove()

		const response = await axios({
			method: "get",
			url:
				process.env.REACT_APP_API_URL_3003 +
				propertyDownload_api +
				"?property_seq=" +
				queryParams +
				"&only_primary=N",
			headers: headers,
			responseType: "blob",
		});

		const blob = new Blob([response.data], { type: response.data.type });
		const downloadUrl = window.URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = downloadUrl;
		const header_filename = response.headers["download-filename"];
		let filename = "date_time";
		if (header_filename) {
			filename = decodeURIComponent(header_filename);
		}
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
		link.remove();
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const attachmentDownload = async (propertySeq, propertyFileSeq) => {
	const attachmentDownload_api = `/dms/property/${propertySeq}/file/${propertyFileSeq}/download`;
	let headers;
	// let queryParams

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		// queryParams = propertySeq.join('&property_seq=')

		const response = await axios({
			method: "get",
			// url: process.env.REACT_APP_API_URL_3003 + attachmentDownload_api + "?property_seq="+queryParams+"&only_primary=N",
			url: process.env.REACT_APP_API_URL_3003 + attachmentDownload_api,
			headers: headers,
			responseType: "blob",
		});

		const blob = new Blob([response.data], { type: response.data.type });
		const downloadUrl = window.URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = downloadUrl;
		const header_filename = response.headers["download-filename"];
		let filename = "date_time";
		if (header_filename) {
			filename = decodeURIComponent(header_filename);
		}
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
		link.remove();
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

// const fileDownload = async (propertySeq, propertyFileSeq) => {
// 	const fileDownload_api = `/dms/property/${propertySeq}/file/download`
// 	let queryParams
// 	let result

// 	try {
// 		let headers = {
// 			"Authorization": "Bearer " + store.get('access_token'),
// 			"site": store.get('site'),
// 			"locale": store.get('locale')
// 		}

// 		queryParams = propertyFileSeq.join('&seqs=')

// 		console.log("queryParams")
// 		console.log()

// 		result = await axios({
// 			method: 'get',
// 			url: process.env.REACT_APP_API_URL_3003 + fileDownload_api + "?seqs=" + queryParams,
// 			headers: headers,
// 			// params: propertyFileSeq,
// 		})

// 		return result.data
// 	}
// 	catch(error) {
// 		try {
// 			if (error.response.status === 401) {
// 				DoRefreshToken()
// 			}
// 			else {
// 				throw new Error(error)
// 			}
// 		}
// 		catch(error) {
// 			throw new Error(error)
// 		}
// 	}
// }


const circulationFileDownload = async (circulationSeq, CirculationMessageSeq, messageFileSeq) => {
	const fileDownload_api = `/circulation/${circulationSeq}/${CirculationMessageSeq}/attachment/${messageFileSeq}`
	//   let queryParams;
	let result;

	try {
		let headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "get",
			url:
				process.env.REACT_APP_API_URL_3006 + fileDownload_api,
			headers: headers,
			responseType: "blob",
		}).then((response) => {
			console.log(response);
			const blob = new Blob([response.data], { type: response.data.type });
			const downloadUrl = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = downloadUrl;
			const header_filename = response.headers["download-filename"];
			let filename = "date_time";
			if (header_filename) {
				filename = decodeURIComponent(header_filename);
			}
			link.setAttribute("download",filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
		});
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};


const fileDownload = async (fileCat, fileRef) => {
	const fileDownload_api = "/file/download";
	let queryParams;
	let result;

	try {
		let headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "get",
			url:
				process.env.REACT_APP_API_URL_3002 +
				fileDownload_api +
				"?file_cat=" +
				fileCat +
				"&file_ref=" +
				fileRef,
			headers: headers,
			responseType: "blob",
		}).then((response) => {
			console.log(response);
			const blob = new Blob([response.data], { type: response.data.type });
			const downloadUrl = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = downloadUrl;
			const header_filename = response.headers["download-filename"];
			let filename = "date_time";
			if (header_filename) {
				filename = decodeURIComponent(header_filename);
			}
			link.setAttribute("download", filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
		});
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const fileUpload = async (file, checksum) => {
	const api = "/file/upload"
	let headers
	let formData = new FormData()
	let result

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
			"content-type": "multipart/form-data",
		}

		formData.append("files", file)

		if (checksum) {
			formData.append("checksum", checksum)
		}

		result = await axios({
			method: "post",
			url: process.env.REACT_APP_API_URL_3002 + api,
			headers: headers,
			data: formData,
		})

		return result.data
	}
	catch (error) {
		if (error.response.status === 401) {
			SignOut()
		}
		else {
			// console.log("Error : ", error)
			throw new Error(error)
			// return error
		}



		// try {
		// 	if (error.response.status === 401) {
		// 		SignOut()
		// 	}
		// 	else {
		// 		throw new Error(error)
		// 	}
		// } 
		// catch (error) {
		// 	throw new Error(error)
		// }

	}
};

const createFileProperty = async (filesProperty) => {
	const api = "/dms/property";
	let headers;
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		result = await axios({
			method: "post",
			url: process.env.REACT_APP_API_URL_3003 + api,
			headers: headers,
			data: filesProperty,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const addFileProperty = async (propertySeq, fileSeq) => {
	const moveProperty_api = `/dms/property/${propertySeq}/file`;
	let headers;
	let params = new URLSearchParams();
	let result;

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		fileSeq.map((res) => {
			params.append("file_seq", res);
		});

		result = await axios({
			method: "post",
			url: process.env.REACT_APP_API_URL_3003 + moveProperty_api,
			headers: headers,
			data: params,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const advancedSearch = async (keyword, folderSeq, page) => {
	const advancedSearch_api = "/dms/property/search";
	let params;
	let result;

	try {
		let headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		params = { ...keyword };
		params.page = page;

		result = await axios({
			method: "post",
			url: process.env.REACT_APP_API_URL_3003 + advancedSearch_api,
			headers: headers,
			data: params,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};

const getFile = async (md5Hash) => {
	const api = "/file?file_cat=dms";
	let result;

	try {
		let headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};

		let params = {
			checksum: md5Hash,
		};

		result = await axios({
			method: "get",
			url: process.env.REACT_APP_API_URL_3002 + api,
			headers: headers,
			params: params,
		});

		return result.data;
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut();
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error);
		}
	}
};


const getLatestInsertProperty = async (folderSeq) => {
	const getLatestInsertProperty_api = `/dms/folder/${folderSeq}/last_property`
	let headers
	let result

	try {
		headers = {
			Authorization: "Bearer " + store.get("access_token"),
			site: store.get("site"),
			locale: store.get("locale"),
		};
		result = await axios({
			method: "get",
			url: process.env.REACT_APP_API_URL_3003 + getLatestInsertProperty_api,
			headers: headers,
		});

		return result.data
	}
	catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			} else {
				throw new Error(error);
			}
		} catch (error) {
			throw new Error(error)
		}
	}
}


export {
	getFolderList,
	getFileList,
	getCompanyList,
	getAdvSearchCompanyList,
	createFolder,
	removeFolder,
	removeFile,
	moveProperty,
	getPropertyDetail,
	updatePropertyDetail,
	removePropertyFile,
	setPrimary,
	propertyDownload,
	attachmentDownload,
	circulationFileDownload,
	fileDownload,
	fileUpload,
	createFileProperty,
	addFileProperty,
	advancedSearch,
	getFile,
	getLatestInsertProperty
};
